// extracted by mini-css-extract-plugin
module.exports = {"group":"group--dsiJA"};